import { IGetTermsAndConditionsFileResponseData } from 'js/hooks/socket/hooks/useGetTermsConditions/types';

import * as Types from './types';

export const getContent = (data: IGetTermsAndConditionsFileResponseData): Types.ITermsConditionsData => {
    const file = data.file || data.base64file;

    const html = Array.isArray(file)
        ? String.fromCharCode.apply(null, file)
        : decodeURIComponent(atob(file).split('')
            .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join(''));

    return {
        content: html,
        version: data.tcVersion
    };
};
